/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import {InjectionToken} from '@angular/core';
import {Observable} from 'rxjs';

export const SEARCH_RESULTS_DATA = new InjectionToken<Observable<any>>('SEARCH_RESULTS_DATA');
